var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[_c('table-list',{attrs:{"columns":_vm.columns,"data":_vm.dataTable,"loading":_vm.loading,"total":_vm.total,"current":_vm.current},on:{"change-page":_vm.changePage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }